import { Globe } from "lucide-react";
import {
  EntitySwitcher,
  type EntitySwitcherProps,
  type SwitcherEntity,
} from "./entity-switcher";

export type { SwitcherEntity } from "./entity-switcher";

const ORG_CONFIG = {
  icon: Globe,
  bg: "bg-purple-600",
  label: "Organizations",
  searchPlaceholder: "Search organizations...",
  emptyLabel: "No organizations found.",
  fallbackName: "Organization",
  requireShiftKey: true,
  separateChildren: false,
} as const;

export type OrganizationSwitcherProps = Omit<
  EntitySwitcherProps,
  "entities" | "activeId"
> & {
  organizations: SwitcherEntity[];
  activeOrganizationId: string;
};

export function OrganizationSwitcher({
  organizations,
  activeOrganizationId,
  ...rest
}: OrganizationSwitcherProps) {
  return (
    <EntitySwitcher
      activeId={activeOrganizationId}
      config={ORG_CONFIG}
      entities={organizations}
      {...rest}
    />
  );
}
